// The insurance policy_type picker options — one canonical list shared by
// every place a human chooses a policy's type: the household page's
// "+ Add policy" form and the record page's "Add policy details" form
// (2026-08-12, Mylah — see policy-details-attach.ts / the
// insurance-policy-attach card). Values must stay in sync with the
// insurance_policies.policy_type CHECK constraint (currently migration
// 0210) — VALID_POLICY_TYPES in workers/api/src/routes/insurance-policies.ts
// is the server-side mirror of this same set.
export const INSURANCE_POLICY_TYPE_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "home", label: "Home" },
  { value: "auto", label: "Auto" },
  { value: "umbrella", label: "Umbrella" },
  { value: "renters", label: "Renters" },
  { value: "condo", label: "Condo" },
  { value: "dwelling_fire", label: "Dwelling / Landlord (rental)" },
  { value: "secondary_home", label: "Secondary / Vacation Home" },
  { value: "watercraft", label: "Watercraft / Boat" },
  // Brandon, 2026-09-29: "Carriers put ATV's and Motorcycles under the same
  // policy." One type, both words.
  { value: "motorcycle", label: "ATV / Motorcycle" },
  { value: "rv", label: "RV / Travel Trailer" },
  { value: "golf_cart", label: "Golf Cart" },
  { value: "flood", label: "Flood" },
  { value: "commercial", label: "Commercial" },
  { value: "life", label: "Life" },
  { value: "health", label: "Health" },
  { value: "medicare", label: "Medicare" },
  { value: "disability", label: "Disability" },
  { value: "long_term_care", label: "Long Term Care" },
  { value: "other", label: "Other" },
];

/**
 * Insurance service_type ("auto_policy") → policy_type ("auto"), for
 * pre-filling the type picker when a record already carries a specific
 * type. Returns null for the generic "insurance_policy" service_type
 * (the won-conversion default when the line of business wasn't known)
 * or anything else that isn't a recognized `${policy_type}_policy` —
 * the caller should leave the picker unset rather than guess.
 */
export function policyTypeFromInsuranceServiceType(serviceType: string): string | null {
  if (!serviceType.endsWith("_policy")) return null;
  const candidate = serviceType.slice(0, -"_policy".length);
  return INSURANCE_POLICY_TYPE_OPTIONS.some((o) => o.value === candidate) ? candidate : null;
}
